module.exports = __webpack_public_path__ + "static/img/3.f59b33a0.jpg";